import classNames from 'classnames';
import { useState } from 'react';

import SiteHeaderState from '../SiteHeaderState';
import StoreAndLanguageSelectorDrawer from '../StoreAndLanguageSelector/StoreAndLanguageSelectorDrawer/StoreAndLanguageSelectorDrawer';
import css from './MegaMenu.css';
import MegaMenuNav from './MegaMenuNav/MegaMenuNav';
import Search from './Search/Search';

interface MegaMenuProps {
  state: SiteHeaderState;
  className?: string;
}

export default function MegaMenu({ className, state }: MegaMenuProps) {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <>
      <MegaMenuNav
        className={classNames(css.menu, { [css.hidden]: isSearchOpen }, className)}
        translation={state.translation.navigation}
        items={state.menuItems}
      />
      <div className={classNames(css.controls, { [css.hidden]: isSearchOpen }, className)}>
        {state.isSearchEnabled && (
          <Search
            isOpen={isSearchOpen}
            translation={state.translation.search}
            onOpenChange={setIsSearchOpen}
            onSearch={state.searchInputState.submit}
          />
        )}
        <StoreAndLanguageSelectorDrawer state={state.storeAndLanguageSelectorState} />
      </div>
    </>
  );
}
